import { GET_MARKET_BY_REGION, SET_MARKET_BY_REGION } from "./MarketByRegionType";

const getMarketByRegion = (regionId?: any) => ({
    type: GET_MARKET_BY_REGION,
    regionId
});

const setMarketByRegion = (marketByRegionDropDownList: any) => ({
    type: SET_MARKET_BY_REGION,
    marketByRegionDropDownList
});

export {
    getMarketByRegion,
    setMarketByRegion
}
